exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-title[data-v-f582375e]{font-size:18px}.menu-list[data-v-f582375e]{font-size:14px;color:#485767;font-weight:500}.menu-label[data-v-f582375e]{font-size:12px;color:#485767;font-weight:700;text-transform:uppercase}", ""]);

// exports
